<mat-toolbar color="accent">{{ title }}</mat-toolbar>

<mat-dialog-content class="!text-black">
  <div class="flex flex-col gap-4">
    <pr-recall-settings
      [brand]="request.brand"
      [track]="track"
      [settings]="request.brand.settings[settingsField]"
      [otherTrack]="
        request.brand.settings[otherTrackField] ? otherTrack : undefined
      "
      [otherTrackTreatmentRefs]="
        request.brand.settings[otherTrackField]?.treatmentRefs ?? []
      "
      (settingsChange)="updatedSettings.set($event)"
    />
    <div>
      <h3 class="!m-0 !font-bold">Update Patient Recalls</h3>
      @if (counts$ | async; as counts) {
        @if (!loadingCounts()) {
          <form [formGroup]="updateFormGroup">
            <mat-checkbox
              formControlName="addMissing"
              [disabled]="!counts.withoutNextDueDate"
            >
              Add next due date for
              <span class="font-bold"
                >{{ counts.withoutNextDueDate }} patients</span
              >
              missing them.
            </mat-checkbox>
            <mat-checkbox
              formControlName="updateExisting"
              [disabled]="!counts.withAutoNextDueDate"
            >
              Update next due date for
              <span class="font-bold"
                >{{ counts.withAutoNextDueDate }} patients</span
              >
              that had them set automatically.
            </mat-checkbox>
            <mat-checkbox
              formControlName="overrideExisting"
              [disabled]="!counts.withExplicitNextDueDate"
            >
              Override next due date for
              <span class="font-bold">
                {{ counts.withExplicitNextDueDate }} patients
              </span>
              that had them set manually.
            </mat-checkbox>
          </form>
        } @else {
          <div class="flex justify-center p-4">
            <mat-spinner diameter="24" />
            <div class="ml-2">Loading patient recalls...</div>
          </div>
        }
      }
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-stroked-button mat-dialog-close>Cancel</button>
  @if (track === RecallTrack.Secondary) {
    <button
      mat-stroked-button
      color="warn"
      (click)="disableSecondary()"
    >
      Disable {{ trackLabel(track) }}
    </button>
  }
  <button
    mat-flat-button
    color="primary"
    [disabled]="!canSubmit()"
    (click)="submit()"
  >
    @if (hasUpdateToApply()) {
      Save &amp; Update Patients
    } @else {
      Save
    }
  </button>
</mat-dialog-actions>
